import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import * as creditCardServices from 'services/creditCardEula';

import { CustomNotification, dialogFunction } from 'common/components';
import { checkPassedRequirementProduct } from 'common/components/product-add/make-product-active/utils';
import { useRefetchAllMemberBillingStatement } from 'pages/company-profile/components/tabs/billing-new/queries';

export const useValidateActiveProduct = ({ productIds }) => {
  const queryClient = useQueryClient();
  const queryKey = ['credit-card', 'validate-active-product', ...productIds];

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      return await creditCardServices.validateActiveProduct({
        productIds,
      });
    },
    retry: 1,
    staleTime: 0,
  });

  const handleRevalidateActiveProduct = () => {
    queryClient.invalidateQueries({
      queryKey,
    });
  };

  return {
    validateProducts: query?.data?.data?.products ?? [],
    passedProducts:
      query?.data?.data?.products?.filter?.((product) =>
        checkPassedRequirementProduct(product.minimumRequirements)
      ) ?? [],
    handleRevalidateActiveProduct,
    ...query,
  };
};

export const mutationProductActiveKeys = ['payment', 'make-product-active'];

export const useMutateMakeProductActive = (props = {}) => {
  const refetchAllMemberBillingStatement =
    useRefetchAllMemberBillingStatement();

  return useMutation({
    mutationKey: mutationProductActiveKeys,
    mutationFn: creditCardServices.fetchProductActiveMaking,
    onSuccess: (response) => {
      if (response?.isSuccess) {
        CustomNotification.success('Make product active successfully');
      } else {
        const errorMsg = response?.message ?? 'Something went wrong';
        dialogFunction({
          type: 'warn',
          content: errorMsg,
          okText: 'OK',
          cancelButtonProps: { style: { display: 'none' } },
        });
      }
      refetchAllMemberBillingStatement();
    },
    onError: () => {
      CustomNotification.error('Failed to make product active');
    },
    ...props,
  });
};
